module.exports = __webpack_public_path__ + "static/media/logo-full.a4d09b2f.svg";